import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

export default function FloatingCoupon({ coupon }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const couponCode = coupon?.coupon_code;

  useEffect(() => {
    if (!couponCode) return;
    const isCopiedStored = sessionStorage.getItem(`coupon_copied_${couponCode}`) === "true";
    const isDismissedStored = sessionStorage.getItem(`coupon_dismissed_${couponCode}`) === "true";

    if (!isCopiedStored && !isDismissedStored) {
      const timer = setTimeout(() => {
        setIsExpanded(true);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [couponCode]);

  if (!coupon) return null;

  const expiryDate = new Date(coupon.expiry_date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const percentOffText = coupon.coupon_type === "Percent" 
    ? `FLAT ${parseFloat(coupon.percent_amount_off).toFixed(0)}% OFF` 
    : `UPTO ${coupon.currencySymbol || '₹'}${parseFloat(coupon.percent_amount_off)} OFF`;

  const headerText = coupon.name || coupon.title || "SPECIAL OFFER";
  const descText = coupon.offer_text || coupon.description || `Apply code ${couponCode} to get a ${coupon.coupon_type === "Percent" ? `Flat ${parseFloat(coupon.percent_amount_off).toFixed(0)}%` : `Flat ${coupon.currencySymbol || '₹'}${parseFloat(coupon.percent_amount_off)}`} discount on your order`;

  const handleCopy = () => {
    if (couponCode) {
      navigator.clipboard.writeText(couponCode);
      setIsCopied(true);
      sessionStorage.setItem(`coupon_copied_${couponCode}`, "true");
      toast.success("Coupon code copied!", {
        position: "bottom-right",
        autoClose: 2000,
      });
      setTimeout(() => {
        setIsExpanded(false);
      }, 1500);
    }
  };

  const handleClose = () => {
    setIsExpanded(false);
    if (couponCode) {
      sessionStorage.setItem(`coupon_dismissed_${couponCode}`, "true");
    }
  };

  return (
    <div className={`floating-coupon-container ${isExpanded ? 'expanded' : 'collapsed'}`}>
      
      {/* Collapsed Tab */}
      <div 
        className="coupon-tab-vertical shadow-sm" 
        onClick={() => setIsExpanded(true)}
      >
        <div className="tab-arrow"><i className="ion-ios-arrow-left"></i></div>
        <div className="tab-text">
          {percentOffText}
        </div>
      </div>

      {/* Expanded Card */}
      <div className="coupon-card-expanded shadow">
        <button className="coupon-close-btn" onClick={handleClose}>✕</button>
        <div className="coupon-card-content">
          <div className="coupon-card-text">
            <div className="coupon-offer-header">
              <h4>{headerText}</h4>
              <h2>{percentOffText}</h2>
            </div>
            
            <p className="coupon-offer-text">
              {descText}
            </p>

            <div className="coupon-code-box">
              <div>
                <span className="code-label d-block">COUPON CODE:</span>
                <span className="code-value">{couponCode}</span>
              </div>
              <button 
                className="coupon-copy-btn" 
                onClick={handleCopy}
                style={isCopied ? { backgroundColor: "#175d31", color: "#ffffff", borderColor: "#175d31" } : {}}
              >
                {isCopied ? "COPIED!" : "COPY"}
              </button>
            </div>
            
            <div className="coupon-footer text-center">
              <p>Valid until {expiryDate}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
